import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Text
} from 'components/ui';
import {
    colors, mediaQueries, radii, shadows, space
} from 'style/config';
import { HISTORY_CARD_STYLES } from 'components/Content/BeautyInsider/BeautyInsiderHistory/historyConstants';

const styles = {
    card: (cardStyle, minHeight) => ({
        backgroundColor: cardStyle === HISTORY_CARD_STYLES.GREY ? colors.nearWhite : colors.white,
        borderRadius: radii[2],
        boxShadow: cardStyle === HISTORY_CARD_STYLES.GREY ? 'none' : shadows.light,
        ...(minHeight && { minHeight }),
        padding: space[4],
        [mediaQueries.sm]: {
            padding: space[5]
        }
    })
};

/**
 * Shared visual shell for BI History cards.
 *
 * Use this component when a History section needs the common card surface, title row, optional title add-on,
 * and optional header action. Section-specific content and status bodies stay in child components.
 */
const HistorySectionCard = ({
    section,
    children = null,
    dataTestId = null,
    headerAction = null,
    headerMarginBottom = 5,
    minHeight = null,
    marginTop = null,
    titleAddon = null
}) => (
    <Box
        marginTop={marginTop}
        css={styles.card(section.cardStyle, minHeight)}
        data-testid={dataTestId}
    >
        <Flex
            alignItems='baseline'
            justifyContent='space-between'
            marginBottom={headerMarginBottom}
        >
            <Flex alignItems='center'>
                <Text
                    is='h2'
                    fontWeight='bold'
                    fontSize={['md', 'lg']}
                    lineHeight='tight'
                    children={section.title}
                />
                {titleAddon}
            </Flex>
            {headerAction}
        </Flex>
        {children}
    </Box>
);

HistorySectionCard.propTypes = {
    section: PropTypes.shape({
        title: PropTypes.string.isRequired,
        cardStyle: PropTypes.oneOf(Object.values(HISTORY_CARD_STYLES))
    }).isRequired,
    children: PropTypes.node,
    dataTestId: PropTypes.string,
    headerAction: PropTypes.node,
    headerMarginBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    marginTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    titleAddon: PropTypes.node
};

export default wrapFunctionalComponent(HistorySectionCard, 'HistorySectionCard');
